const mediaQuery = "(min-width: 576px)";
const mediaQueryList = window.matchMedia(mediaQuery);

const videoIframes = document.querySelectorAll('.jumbotron iframe');

const setSrc = function (mq, iframe, src) {
  if (mq.matches) {
    iframe.setAttribute('src', src);
  } else {
    iframe.removeAttribute('src');
  }
}

videoIframes.forEach((iframe) => {
  const src = iframe.getAttribute('data-src');
  setSrc(mediaQueryList, iframe, src);

  mediaQueryList.addEventListener('change', e => {
    setSrc(e, iframe, src);
  })
});

/* This is breaking the register link so commenting out for now
$('.modal').on('hidden.bs.modal', function () {
  console.log('Testing hidden.bs.modal event');
  const video = VidyardV4.players[0];
  console.log(video)
  video.pause();
});
*/